import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import "react-datepicker/dist/react-datepicker.css";
import CheckboxTable from "../commonTables/CheckboxView.jsx";
import ModalView from "../commonViews/ModalView.jsx";
import IconPicker from "../commonViews/IconPicker.jsx";
import ButtonHandler from "../commonViews/ButtonHandler.jsx";
import {
    fetchHersheysVisibilityStoresAction,
    HerysheysVisibilityAssignAuditsAction,
    fetchAuditorsDetailAction,
} from "../../actions/hersheys_actions";
import { fetchUserDetailAction } from "../../actions/user_detail_action";
import HVAuditDetails from "./HVAuditDetails"
import "react-notifications/lib/notifications.css";
import {
    NotificationContainer,
    NotificationManager,
} from "react-notifications";
import TableView from "../commonViews/TableView.jsx";
import {
    getTextColor,
    getMainBackground,

    getFontColor,
} from "../../ThemeHandlers/theme";
import Metrics from "../commonViews/Metrics.jsx";

export class HVAudits extends Component {
    constructor(props) {
        super(props);
        this.checkboxTable = null;

        this.setHersheysCheckboxRef = (element) => {
            this.checkboxTable = element;
        };

        this.state = {
            CustomerTableView: true,
            selectedCustomer: {},
            auditid: "",
            customerSearch: "",
            filteredData: [],
            modalOpen: false,
            selectedRegion: "",
            selectedState: "",
            selectedCity: "",
            selectedStatus: "",
            selection: [],
            userId: [],
            selectAll: false,
            hershysCustomers: [],
            hershysFilters: [],
            userDetails: [],
            assignData: [],
            isLoading: false,
        };
    }
    componentDidMount() {
        this.setState({ isLoading: true });
        this.props.fetchHersheysVisibilityStoresAction({
            id: this.props.selectedTemplate._id,
            onSuccess: () => {
                this.setState({ isLoading: false });
            },
            onFailure: () => {
                this.setState({ isLoading: false });
            },
        });
        this.props.fetchAuditorsDetailAction();
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.hersheys.customers !== nextProps.hersheys.customers) {
            this.setState({
                selectedRegion: "All",
                selectedCity: "All",
                selectedStatus: "All",
                filteredData: nextProps.hersheys.customers,
            });
        }
    }
    componentDidUpdate(prevProps) {
        if (this.props.hersheys.customers !== undefined) {
            if (
                this.props.hersheys.filters === undefined &&
                this.props.hersheys.customers !== prevProps.hersheys.customers
            ) {
                this.setState({
                    hershysCustomers: this.props.hersheys.customers,
                });
            } else if (
                this.props.hersheys?.filters !== undefined &&
                this.props.hersheys.filters !== prevProps.hersheys.filters
            ) {
                this.setState({
                    hershysCustomers: this.props.hersheys.filters,
                });
            }
        }
        if (this.props.hersheys.userDetails !== prevProps.hersheys.userDetails) {
            this.setState({
                userDetails: this.props.hersheys.userDetails,
            });
        }
    }
    auditIdFromHersheysAudit = (auditId) => {
        this.setState({
            auditid: auditId,
        });
    };

    hersheyshandleTableViewAuditClick = (customer) => {
        this.setState({ selectedCustomer: customer, CustomerTableView: false });
    };
    onGotoCustomerView = () => {
        this.setState({
            CustomerTableView: true,
        });
    };

    searchFilter = (filter, row) => {
        let value = filter.value && filter.value.toLowerCase();

        if (filter.id) {
            var flatedData = JSON.stringify(
                row._original[filter.id] ? row._original[filter.id] : ""
            );
            return flatedData.toLowerCase().includes(value);
        }
    };

    addNewUser = () => {
        if (this.state.assignData.length !== 0) {
            this.setState({ modalOpen: true });

        } else {
            alert('Please Select the Stores to Assign')
        }
    };
    closeEditUser = () => {
        this.setState({ modalOpen: false });
    };

    userAssign = () => {
        this.setState({
            modalOpen: false,
            assignData: [],
        });
    };

    removeDuplicates = (e) => {
        let newArray = [];
        let UniqueObject = {};
        for (let i in e) {
            let objTitle = e[i]["text"];
            UniqueObject[objTitle] = e[i];
        }
        for (let i in UniqueObject) {
            newArray.push(UniqueObject[i]);
        }

        return newArray;
    };

    sendedData = (rowData, row) => {
        console.log(rowData, 'row')
        let ids = [];
        let check = [];

        if (rowData.length !== 0) {
            rowData.forEach((data) => {
                ids.push(data._id);
                if (data.status == 'Completed') {
                    check.push(data._id)
                }
            });
        }
        console.log(check, 'check')
        if (check.length !== 0) {
            this.setState({
                assignData: [],
            });
        }
        else {
            this.setState({ assignData: ids })
        }
    };

    userData = (rowData, checkedValue) => {
        var selectedData = this.state.assignData;
        let formAssignData = {
            userId: rowData._id,
            storeId: selectedData,
        };
        this.props.HerysheysVisibilityAssignAuditsAction({
            assignData: formAssignData,
            onSuccess: () => {
                this.setState({ isLoading: true });
                // alert("Audits Assigned Successfully")
                this.props.fetchHersheysVisibilityStoresAction({
                    id: this.props.selectedTemplate._id,
                    onSuccess: () => {
                        this.setState({ isLoading: false, assignData: [], modalOpen: false });
                    },
                    onFailure: () => {
                        this.setState({ isLoading: false, assignData: [] });
                    },
                });

                NotificationManager.success(
                    "Audits Assigned Successfully",
                    "SUCCESS MESSAGE",
                    3000,
                    true
                );
            },
            onFailure: () => {
                NotificationManager.error(
                    "Audit Not Assigned",
                    "ERROR MESSAGE",
                    3000,
                    true
                );
            },
        });
    };

    render() {
        var customers;
        if (this.state.hershysCustomers.length !== 0) {
            customers = this.state.hershysCustomers;
        } else {
            customers = this.state.hershysFilters;
        }
        var unique;
        var cityData = [];
        let uniqueCity;
        let status = [
            {
                text: "Pending",
                value: "Pending",
            },
            {
                text: "Assigned",
                value: "Assigned",
            },
            {
                text: "In Progress",
                value: "In Progress",
            },
            {
                text: "Completed",
                value: "Completed",
            },
            {
                text: "All",
                value: "All",
            },
        ];

        var UserList =
            this.state.userDetails.length !== 0 ? this.state.userDetails : [];

        if (this.props.hersheys.customers != undefined) {
            var regionList = this.props.hersheys.customers;
            regionList.map((e) => {
                cityData.push({ text: e.city, value: e.city });
            });
        }
        if (cityData.length > 0) {
            uniqueCity = this.removeDuplicates(cityData);
        }

        const newHershysCol = [
            {
                title: "Outlet Code",
                field: "code",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.code}
                    </span>
                ),
            },
            {
                title: "Outlet Name",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.name}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.name.toLowerCase().indexOf(term.toLowerCase()) > -1,
            },
            {
                title: "Distributor Name",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.distName}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.distName.toLowerCase().indexOf(term.toLowerCase()) >
                    -1,
            },
            {
                title: "OL Type",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.olType}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.olType.toLowerCase().indexOf(term.toLowerCase()) >
                    -1,
            },
            {
                title: "Tier",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.tier}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.tier.toLowerCase().indexOf(term.toLowerCase()) >
                    -1,
            },

            {
                title: "TSI Name",
                field: "",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.tsiName}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.tsiName.toLowerCase().indexOf(term.toLowerCase()) > -1,
            },
            {
                title: "TSI Beat Name",
                field: "tsiBeatName",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.beat}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.beat.toLowerCase().indexOf(term.toLowerCase()) > -1,
            },
            {
                title: "Status",
                field: "status",
                filtering: true,
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.status}
                    </span>
                ),
            },
            {
                title: "Assignee",
                field: "userName",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.userName}
                    </span>
                ),
            },
            {
                title: "Pincode",
                field: "outletAddress",
                render: (rowData) => (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            this.hersheyshandleTableViewAuditClick(rowData);
                        }}
                    >
                        {rowData.pinCode}
                    </span>
                ),
                customFilterAndSearch: (term, rowData) =>
                    rowData.pinCode.toLowerCase().indexOf(term.toLowerCase()) > -1,
            },
        ];

        const column = [
            {
                Header: "Email Id's",
                accessor: "email",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.email}</span>;
                },
            },
        ];
        return (
            <div>
                <NotificationContainer />
                {this.state.CustomerTableView && (
                    <div>
                        <div style={{ display: "inline-block", marginBottom: 20 }}>
                            <IconPicker
                                name="arrow left"
                                click={this.props.onClose}
                                styles={{
                                    color: getTextColor(this.props.color),
                                    float: "right",
                                    cursor: "pointer",
                                    marginTop: 35,
                                    position: "absolute",
                                    right: 20,
                                }}
                            />
                            <h1
                                style={{
                                    display: "inline-block",
                                    color: getTextColor(this.props.color),
                                }}
                            >
                                Hersheys Visibility Stores
                            </h1>

                        </div>
                        <div style={{ display: "inline-block", marginBottom: 20, marginLeft: 30 }}>
                            <ButtonHandler
                                title={'Assign Audits'}
                                size={'Medium'}
                                click={this.addNewUser}
                                styles={{
                                    cursor: "pointer",
                                    width: "100%",
                                    backgroundColor: getMainBackground(this.props.color),
                                    color: getFontColor(this.props.color),
                                }}
                                isIcon={true}
                                iconName={'add'}
                                disabled={this.state.assignData.length === 0}
                            />
                        </div>
                        <div style={{ marginTop: 10 }}>
                            {this.props.hersheys.metrics !== undefined &&
                                Object.keys(this.props.hersheys.metrics).length !== 0 &&
                                this.props.hersheys.metrics && (<Metrics metrics={this.props.hersheys.metrics} color={this.props.color} />

                                )}
                        </div>
                    </div>
                )}
                {this.state.CustomerTableView && (
                    <div
                        style={{
                            display: "flex",
                            flexGrow: 1,
                            flexFlow: "column",
                            marginTop: 20,

                        }}
                    >
                        <TableView
                            selection={true}
                            data={customers.length !== 0 ? customers : []}
                            columns={newHershysCol}
                            load={this.state.isLoading}
                            onSelectionChange={(rows, row) => this.sendedData(rows, row)}
                        />

                    </div>
                )}


                <ModalView
                    open={this.state.modalOpen}
                    close={this.closeEditUser}
                    size={'small'}
                    content={
                        <CheckboxTable
                            data={UserList}
                            columns={column}
                            sendedData={this.userData}
                        />
                    }
                    showSave={true}
                    saveClick={this.userAssign}
                />

                {!this.state.CustomerTableView && (
                    <div style={{ flexGrow: 1, display: "flex" }}>
                        <HVAuditDetails
                            template={this.props.template}
                            customer={this.state.selectedCustomer}
                            onClose={this.onGotoCustomerView}
                            auditId={this.auditIdFromHersheysAudit}
                            color={this.props.color}
                        />
                    </div>
                )}
            </div>
        );
    }
}

function AuditTableCell(props) {
    function onClick() {
        props.onClick(props.row);
    }
    return (
        <div style={props.style} onClick={onClick}>
            {props.text}
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        hersheys: state.hersheys,
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            fetchHersheysVisibilityStoresAction,
            fetchUserDetailAction: fetchUserDetailAction,
            HerysheysVisibilityAssignAuditsAction,
            fetchAuditorsDetailAction: fetchAuditorsDetailAction,
        },
        dispatch
    );
};
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(HVAudits)
);
